'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { getSession } from '@/lib/session';

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    const user = getSession();
    if (!user) {
      router?.replace('/sign-up-login-screen');
      return;
    }

    // Role-based landing page
    switch (user?.cargo) {
      case 'Administrador':
        // Admin sees financial dashboard
        router?.replace('/dashboard');
        break;
      case 'Gerente':
        // Manager sees operational indicators
        router?.replace('/dashboard-dia');
        break;
      case 'Funcionário':
        // Employee sees only daily functions (PDV)
        router?.replace('/vendas');
        break;
      default:
        router?.replace('/dashboard');
    }
  }, [router]);

  return (
    <div className="flex items-center justify-center h-screen bg-background">
      <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}